import { NumberFormatter } from "@mantine/core";

import Icon       from "_components/atoms/icon";
import Link       from "_components/atoms/link";
import Render     from "_components/atoms/render";
import Typography from "_components/atoms/typography";

import CalculationModal from "../components/calculationModal";
import Header           from "../components/header";
import History          from "../components/history";
import Information      from "../components/information";

import useStyles from "./styles";

function component ( {
	openInfo,
	setOpenInfo,
	details,
	fetchMore,
	history,
	isDepleted,
	isLoading,
	showCalc,
	setShowCalc
} ) {
	const { classes, cx } = useStyles ();

	return (
		<div className = { classes.parent }>
			<Header
				backRoute = "/diamond-payout"
				title     = "Manage Donation"
			/>

			<div className = { classes.balanceContainer }>
				<div className = { classes.balanceChild }>

					<Typography
						size   = "sm"
						title  = "Donation Balance"
						weight = { 500 }
					/>

					<Icon
						name    = { "info" }
						onClick = { () => {
							setOpenInfo ( p => !p );
						} }
						size    = { 16 }
					/>
				</div>

				<div className = { classes.balanceChild }>
					<Icon
						sameInBothTheme
						className = { classes.diamondIcon }
						name      = "diamond"
					/>

					<span className = { classes.balanceChildText }>
						<Typography
							className = { classes.donationBalanceText }
							title     = { (
								<NumberFormatter thousandSeparator = { true }
									thousandsGroupStyle               = { "lakh" }
									value                             = { details?.donationDiamonds }
								/>
							) }
							weight    = { 500 }
						/>

						<Typography
							size  = "xs"
							title = { "≈" }
						/>

						<Typography
							className = { classes.donationBalanceText }
							size      = "xs"
							title     = { (
								<NumberFormatter
									prefix              = "₹"
									thousandSeparator   = { true }
									thousandsGroupStyle = { "lakh" }
									value               = { ` ${ details?.beforeTaxAmount }` }
								/>
							) }
							weight    = { 500 }
						/>
					</span>
				</div>

				<Render condition = { details?.taxPercentage === 20 /* if pan is added, tax will be less than 20*/ }>
					<div className = { classes.balanceChild }>
						<Icon
							className       = { cx ( classes.infoIcon, classes.linkIcon ) }
							name            = "infoIdeaIcon"
							onClick         = { () => { } }
							sameInBothTheme = { true }
						/>

						<Typography
							dimmed
							size  = "xs"
							title = "Add PAN and save 18% tax. "
						/>

						<Link href = { { pathname: "/diamond-payout/autopay-settings" } }>
							<Typography
								dimmed
								className = { classes.addNowLink }
								size      = "xs"
								title     = "Add Now"
							/>

						</Link>
					</div>
				</Render>
			</div>

			<History
				fetchMore  = { fetchMore }
				history    = { history }
				isDepleted = { isDepleted }
				isLoading  = { isLoading }
			/>

			<Information
				onClose       = { () => {
					setOpenInfo ( false );
				} }
				openCalcModal = { () => {
					setOpenInfo ( false );
					setShowCalc ( true );
				} }
				opened        = { openInfo }
			/>

			<CalculationModal
				onClose = { () => {
					setShowCalc ( false );
				} }
				opened  = { showCalc }
			/>
		</div>
	);
}

export default component;
